import { LoginDialogComponent } from '../widget/login/login-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "@angular/router";
export class LoginDialogService {
    constructor(dialog, router) {
        this.dialog = dialog;
        this.router = router;
        this.isOpen = false;
    }
    open(options = {}) {
        // Évite à la popup de s'ouvrir plusieurs fois
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        const modalRef = this.dialog.open(LoginDialogComponent, { disableClose: true });
        modalRef.afterClosed().subscribe(() => {
            this.isOpen = false;
            const referer = options.referer;
            const callback = options.callback;
            if (!!referer) {
                if (referer.startsWith('http')) {
                    window.location.href = referer;
                }
                else {
                    this.router.navigateByUrl(referer);
                }
            }
            if (!!callback && typeof callback === 'function') {
                callback();
            }
        }, () => {
            this.isOpen = false;
        });
        return modalRef;
    }
}
LoginDialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginDialogService_Factory() { return new LoginDialogService(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(i2.Router)); }, token: LoginDialogService, providedIn: "root" });
